import React from "react";
import { useLocation } from "react-router-dom";
import DashboardSection from "../../Sections/Dashboard/PaycentralDashboard";
import PaycentralDashboard from "./Dashboard";

const DashboardComponent = () => {
  const location = useLocation();

  const dashboardType =
    location.pathname === "/paycentral-dashboard"
      ? "paycentral"
      : "qbot";

  return (
    <PaycentralDashboard
      sectionName={<DashboardSection dashboardType={dashboardType} />}
    />
  );
};

export default DashboardComponent;